import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomCodeComponent} from './custom-code.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthenticationNativeComponent } from './authentication-native/authentication-native.component';
import { AuthenticationUrlComponent } from './auth-url/auth-url.component';
import { CustomCodeListComponent } from './customCode-list/customCode-list.component';

const routes: Routes = [
    { 
      path: '', 
      component: CustomCodeListComponent
    },
    {
      path: 'edit/:customCode',
      component: CustomCodeComponent
    },
    {
      path: 'authentication/:customCode',
      component: AuthenticationComponent
    },
    {
      path: 'authentication-native/:customCode',
      component: AuthenticationNativeComponent
    },
    {
      path: 'auth-url/:customCode',
      component: AuthenticationUrlComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomCodeRoutingModule {}